"use strict";

// see https://w3c.github.io/webrtc-pc/#perfect-negotiation-example
export function newConnNegotiated(signaling, isPolite, configuration) {
	const pc = new RTCPeerConnection(configuration);

	let makingOffer = false;
	let ignoreOffer = false;
	let isSettingRemoteAnswerPending = false;

	pc.onicecandidate = ({candidate}) => {
		if (candidate) {
			signaling.send({candidate});
		}
	};

	pc.onnegotiationneeded = async () => {
		try {
			makingOffer = true;
			await pc.setLocalDescription();
			signaling.send({description: pc.localDescription});
		} catch (err) {
			console.error(err);
		} finally {
			makingOffer = false;
		}
	};

	pc.oniceconnectionstatechange = () => {
		if (pc.iceConnectionState === "failed") {
			pc.restartIce();
		}
	};

	signaling.onmessage = async ({description, candidate}) => {
		try {
			if (description) {
				// An offer may come in while we are busy processing SRD(answer).
				// In this case, we will be in "stable" by the time the offer is processed
				// so it is safe to chain it on our Operations Chain now.
				const readyForOffer = !makingOffer &&
					(pc.signalingState == "stable" || isSettingRemoteAnswerPending);
				const offerCollision = description.type == "offer" && !readyForOffer;

				ignoreOffer = !isPolite && offerCollision;
				if (ignoreOffer) {
					return;
				}
				isSettingRemoteAnswerPending = description.type == "answer";
				await pc.setRemoteDescription(description); // SRD rolls back as needed
				isSettingRemoteAnswerPending = false;
				if (description.type == "offer") {
					await pc.setLocalDescription();
					signaling.send({description: pc.localDescription});
				}
			} else if (candidate) {
				try {
					await pc.addIceCandidate(candidate);
				} catch (err) {
					// Suppress ignored offer's candidates
					if (!ignoreOffer) throw err;
				}
			}
		} catch (err) {
			console.error(err);
		}
	};

	return pc;
}
